import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { wrapIdForPic } from '@framework/workbench/util/wrap-id-util';
import { TOOLBAR_RESET_PICTURE_ICON } from '@editor/src/img/pageIndex';

export const config = {
    id: ActionType.RESET_PICTURE,
    tipMsg: i18n.t('重置图片'),
    content: i18n.t('重置图片'),
    icon: TOOLBAR_RESET_PICTURE_ICON,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: wrapIdForPic(config.id),
        hasArrow: true,
        text: i18n.t('重置图片'),
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''} />,
        style: {
            width: 'auto',
        },
    },
];

export const RESET_PICTURE_SELF_CONFIG: MenuConfig = {
    name: ActionType.RESET_PICTURE_SELF,
    content: i18n.t<string>('重置图片'),
    tooltip: i18n.t<string>('重置图片'),
};

export const RESET_PICTURE_SIZE_CONFIG: MenuConfig = {
    name: ActionType.RESET_PICTURE_SIZE,
    content: i18n.t<string>('重置图片及其大小'),
    tooltip: i18n.t<string>('重置图片及其大小'),
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
    },
    RESET_PICTURE_SELF_CONFIG,
    RESET_PICTURE_SIZE_CONFIG,
];
